import { Component } from '@angular/core';
import { CurrentSiteService } from '../../../shared/services/current-site.service';
import { DataCollection } from '../../../shared/models/site-content/data-collection.model';
import { DataCollectionService } from '../../../shared/services/data-collection.service';
import { BannerText } from '../../../shared/models/banner/banner-text.model';

class ColorPair {
  name: string;
  value: string;
}

@Component({
    selector: 'app-configure-banner',
    templateUrl: './configure-banner.component.html',
    styleUrls: ['./configure-banner.component.scss'],
    standalone: false
})
export class ConfigureBannerComponent {

  public leftText: string;
  public centerText: string;
  public rightText: string;

  public textColor: string;
  public backgroundColor: string;

  private site: DataCollection;

  private isEditing: boolean = false;

  public colors: ColorPair[] = [
    { name: 'Gold', value: "#d8b304" } as ColorPair,
    { name: 'Primary Blue', value: "#000030" } as ColorPair,
    { name: 'Second Blue', value: "#00aeef" } as ColorPair, 
    { name: 'Green', value: "#007a48" } as ColorPair, 
    { name: 'Red', value: "#ed1c24" } as ColorPair,
    { name: 'White', value: "#ffffff" } as ColorPair
  ];

  constructor(private currentSiteService: CurrentSiteService,
    private dataCollectionService: DataCollectionService) {
    this.site = this.currentSiteService.Site;

    if (this.site.leftBannerText) {
      this.leftText = this.site.leftBannerText;
    }

    if (this.site.centerBannerText) {
      this.centerText = this.site.centerBannerText;
    }

    if (this.site.rightBannerText) {
      this.rightText = this.site.rightBannerText;
    }

    if (this.site.backgroundColor) {
      this.backgroundColor = this.site.backgroundColor;
    }

    if (this.site.textColor) {
      this.textColor = this.site.textColor;
    }
  }

  public get IsEditing(): boolean {
    return this.isEditing;
  }


  public editClicked() {
    this.isEditing = true;
  }

  public saveClicked() {

    this.isEditing = false;

    const toPass = {
      dataCollectionId: this.currentSiteService.Site.id,
      leftBannerText: this.leftText,
      centerBannerText: this.centerText,
      rightBannerText: this.rightText,
      backgroundColor: this.backgroundColor,
      textColor: this.textColor
    } as BannerText;

    this.dataCollectionService.updateBannerText(toPass).then(response => {
      this.site.leftBannerText = this.leftText;
      this.site.centerBannerText = this.centerText;
      this.site.rightBannerText = this.rightText;

      this.site.backgroundColor = this.backgroundColor;
      this.site.textColor = this.textColor;
    });
  }



}
